import config from '../config';
import selectedEnvironment from '../env';

const API_URL = `${config[selectedEnvironment].API_URL}/NationalInsurance`;

/** Fired on window after National Insurance data was imported or edited; detail: { caseIds }. */
export const NATIONAL_INSURANCE_SAVED_EVENT = 'nationalInsurance:saved';

const handleResponse = async (response) => {
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `HTTP ${response.status}`);
    }
    return response.json();
};

const post = async (path, body, token) =>
    handleResponse(await fetch(`${API_URL}/${path}`, {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }));

/**
 * Parses an NI advances file (".XLA.HTM") and matches its rows to the client `caseId`, or to all of
 * the accountant's clients when `caseId` is empty. Nothing is saved.
 */
const preview = async ({ accountantId, caseId = null, file }, token) => {
    const form = new FormData();
    form.append('AccountantId', accountantId);
    if (caseId) form.append('CaseId', caseId);
    form.append('File', file);

    return handleResponse(await fetch(`${API_URL}/Preview`, {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + token },
        body: form,
    }));
};

/** Saves the previewed rows as each client's yearly values: `{ created, updated, skipped }`. */
const commit = ({ accountantId, year, asOfDate, officeName, sourceFileName, rows }, token) =>
    post('Commit', { accountantId, year, asOfDate, officeName, sourceFileName, rows }, token);

/** Yearly values, start month and the 12 effective month rows of a client. */
const getClientYear = ({ caseId, year }, token) =>
    post('GetClientYear', { caseId, year }, token);

/** Stores manually edited yearly values and month overrides; returns the fresh client year. */
const saveClientYear = ({ caseId, year, values, monthOverrides }, token) =>
    post('SaveClientYear', { caseId, year, values, monthOverrides }, token);

const NationalInsuranceService = {
    preview,
    commit,
    getClientYear,
    saveClientYear,
};

export default NationalInsuranceService;
